import { action } from 'typesafe-actions';
// eslint-disable-next-profile no-unused-vars
import { asyncAction } from 'store/utils/promiseAction';
import {
  ProfilesTypes,
  ProfileInterface,
  ProfileLineInterface,
  OperationTypes,
  CidInterface,
} from './types';

// List Profiles
export const listProfilesRequest = (payload: {
  params?: object;
  loading?: boolean;
  filtering?: boolean;
}) => asyncAction(ProfilesTypes.LIST_PROFILES_REQUEST, payload);
export const listProfilesSuccess = (payload: {
  profilesList: ProfileInterface[];
  totalCount: number;
}) => action(ProfilesTypes.LIST_PROFILES_SUCCESS, payload);
export const listProfilesFailure = () =>
  action(ProfilesTypes.LIST_PROFILES_FAILURE);

// List Profile Lines
export const listProfileLinesRequest = (payload: object) =>
  action(ProfilesTypes.LIST_PROFILE_LINES_REQUEST, payload);
export const listProfileLinesSuccess = (payload: {
  profileLines: ProfileLineInterface[];
}) => action(ProfilesTypes.LIST_PROFILE_LINES_SUCCESS, payload);
export const listProfileLinesFailure = () =>
  action(ProfilesTypes.LIST_PROFILE_LINES_FAILURE);

// Get Cid
export const getCidRequest = (payload: object) =>
  action(ProfilesTypes.GET_CID_REQUEST, payload);
export const getCidSuccess = (payload: { cid: CidInterface }) =>
  action(ProfilesTypes.GET_CID_SUCCESS, payload);
export const getCidFailure = () => action(ProfilesTypes.GET_CID_FAILURE);

// Filter Profiles
export const filterProfilesRequest = (payload: object) =>
  asyncAction(ProfilesTypes.FILTER_PROFILES_REQUEST, payload);
export const filterProfilesSuccess = (payload: {
  filterProfilesList: ProfileLineInterface[];
  totalCount: number;
}) => action(ProfilesTypes.FILTER_PROFILES_SUCCESS, payload);
export const filterProfilesFailure = () =>
  action(ProfilesTypes.FILTER_PROFILES_FAILURE);

// Get Profile
export const getProfileRequest = (payload: any) =>
  action(ProfilesTypes.GET_PROFILE_REQUEST, payload);
export const getProfileSuccess = (payload: { profileData: ProfileInterface }) =>
  action(ProfilesTypes.GET_PROFILE_SUCCESS, payload);
export const getProfileFailure = () =>
  action(ProfilesTypes.GET_PROFILE_FAILURE);

// Create Profile
export const createProfileRequest = (payload: any) =>
  action(ProfilesTypes.CREATE_PROFILE_REQUEST, payload);
export const createProfileSuccess = (payload: {
  profileCreated: ProfileInterface;
}) => action(ProfilesTypes.CREATE_PROFILE_SUCCESS, payload);
export const createProfileFailure = () =>
  action(ProfilesTypes.CREATE_PROFILE_FAILURE);

// Update Profile
export const updateProfileRequest = (payload: any) =>
  action(ProfilesTypes.UPDATE_PROFILE_REQUEST, payload);
export const updateProfileSuccess = () =>
  action(ProfilesTypes.UPDATE_PROFILE_SUCCESS);
export const updateProfileFailure = () =>
  action(ProfilesTypes.UPDATE_PROFILE_FAILURE);

// Update Order
export const updateOrderRequest = (payload: { profiles: any[] }) =>
  action(ProfilesTypes.UPDATE_ORDER_PROFILE_REQUEST, payload);
export const updateOrderSuccess = () =>
  action(ProfilesTypes.UPDATE_ORDER_PROFILE_SUCCESS);
export const updateOrderFailure = () =>
  action(ProfilesTypes.UPDATE_ORDER_PROFILE_FAILURE);

// Delete Profile
export const deleteProfileRequest = (payload: object) =>
  action(ProfilesTypes.DELETE_PROFILE_REQUEST, payload);
export const deleteProfileSuccess = () =>
  action(ProfilesTypes.DELETE_PROFILE_SUCCESS);
export const deleteProfileFailure = () =>
  action(ProfilesTypes.DELETE_PROFILE_FAILURE);

// Set Current Operation
export const setCurrentOperation = (payload: { operation: OperationTypes }) =>
  action(ProfilesTypes.SET_CURRENT_OPERATION, payload);

// Set Profile Selected
export const setProfileSelected = (payload: {
  profileSelected: ProfileInterface;
}) => action(ProfilesTypes.SET_PROFILE_SELECTED, payload);

// Reset Profile Selected
export const resetProfileSelected = () =>
  action(ProfilesTypes.RESET_PROFILE_SELECTED);
